import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { isNumber } from '../utils/validationUtils';

class CBATable extends Component {

    constructor(props) {
        super(props);

        this.state = { data: null, standalone: false };
        this.addRow = this.addRow.bind(this);
        this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
    }


    componentDidMount() {
        this.setState({
            data: JSON.parse(this.props.data),
            standalone: this.props.standalone ? JSON.parse(this.props.standalone) : false
        });
    }

    updateProperty(property, value) {
        let newData = this.state.data;
        newData[property] = value;
        this.setState({ data: newData });
    }

    onTextEditorValueChange(field, props, modifiedRowIndex, modifiedField, value) {
        let updatedValues = [...props.value];
        updatedValues[modifiedRowIndex][modifiedField] = value;
        this.updateProperty(field, updatedValues);
    }

    tableEditor(options) {
        return <InputText type="text" defaultValue={options.value} onChange={(e) => this.onTextEditorValueChange('kpis', options.props, options.rowIndex, options.field, e.target.value)} />;
    }

    addRow() {
        this.setState({data: [...this.state.data, {label: 'New Row', capex: '', opex: '', benefits: '', years: '', discount: ''}]})
    }

    deleteRow(rowData) {
        let newData = this.state.data;
        newData = newData.filter(element => element !== rowData);
        this.setState({ data: newData });
    }

    actionBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <Button icon="pi pi-trash" severity="danger" link style={{color: '#e91224', width: '20px', height: '20px'}} onClick={() => this.deleteRow(rowData)} />
            </React.Fragment>
        );
    }

    render() {
        return (
            <div>
                {this.state.data &&
                    <input id='cba_table_data' type="hidden" value={JSON.stringify(this.state.data)} />
                }
                <DataTable emptyMessage='Add new rows by using the button below.' value={this.state.data} editMode="cell" footer={this.state.standalone ? <Button label="Add Row" icon="pi pi-plus" onClick={this.addRow}/> : undefined}>
                    <Column key='label' field='label' header='Name' editor={this.state.standalone ? (options) => this.tableEditor(options) : undefined} />
                    <Column key='value' field='capex' header='CAPEX' editor={(options) => this.tableEditor(options)} />
                    <Column key='value' field='opex' header='OPEX' editor={(options) => this.tableEditor(options)} />
                    <Column key='value' field='benefits' header='Benefits' editor={(options) => this.tableEditor(options)} />
                    <Column key='value' field='years' header='Years' editor={(options) => this.tableEditor(options)} />
                    <Column key='value' field='discount' header='Discount Rate (%)' editor={(options) => this.tableEditor(options)} />
                    {this.state.standalone ? <Column body={this.actionBodyTemplate} exportable={false} style={{ width: '8px' }}></Column> : undefined}
                </DataTable>
            </div>
        );
    }
}



export default CBATable;